<div class="col-lg-12 p-0 float-right">
  <div class="border upload-files float-right rounded">
    @if (quote?.quoteAttachment) {
      <label class="m-0 float-left">
        <a (click)="openModal()" class="font-color-knbr-primary download-links float-left font-sm-size">
          {{ quote.quoteAttachment }}
        </a>
      </label>
      <!-- <button
      class="btn pl-3 float-left mr-1 color-upload-bg text-dark pr-3 pb-2 pt-2 font-size-17 color-white h-auto hover-link rounded-0 border-0"
      (click)="removeFile()"
      *ngIf="quote && !isDisabled()"
      >
      <i class="far fa-trash-alt"></i>
    </button> -->
  }
  @if (quote && !isDisabled()) {
    <!-- <file-upload simple [control]="fileUploadControl" class="d-inline-flex border-0" *ngIf="!quote?.quoteAttachment">
    <ng-template let-file #placeholder> </ng-template>
    <ng-template let-control="control" #button>
      <i
        class="fas fa-paperclip btn color-upload-bg text-dark font-size-17 color-white h-auto hover-link rounded-0"
        aria-hidden="true"
      ></i>
    </ng-template>
  </file-upload> -->
  @if (quote?.quoteAttachment) {
    <button
      class="btn float-left text-dark font-size-17 color-white h-auto hover-link rounded-0 border-0"
      (click)="onSubmit()"
      >
      <i class="fas fa-paperclip"></i>
    </button>
  }
}
</div>
</div>
